const MAX_UPLOAD_SIZE = 1000000;
const MAX_IMAGE_WIDTH = 200;
export function imageUploader(dialog) {
    dialog.addEventListener('imageuploader.cancelupload', function() {
        dialog.clear();
        dialog.domElement().previousElementSibling.remove();
        dialog.hide();
    });
    dialog.addEventListener('imageuploader.fileready', function(ev) {
        const file = ev.detail().file;
        const size = file && file.size;
        if (size < MAX_UPLOAD_SIZE) {
            const upload = dialog.domElement().querySelector('.ct-control--upload');
            upload.classList.remove('is-error');
            const reader = new FileReader();
            reader.onload = event => {
                const imageUrl = event.target.result;
                var img = new Image();
                img.onload = function() {
                    const ratio = img.width / MAX_IMAGE_WIDTH;
                    dialog.save(imageUrl, [MAX_IMAGE_WIDTH, img.height / ratio], {});
                };
                img.src = imageUrl;
            };
            reader.readAsDataURL(file);
        } else {
            const upload = dialog.domElement().querySelector('.ct-control--upload');
            upload.classList.add('is-error');
        }
    });
}



// WEBPACK FOOTER //
// ./src/lib/contenttools/imageUploader.js